<template>
  <section class="auth-section" id="reset-password">
    <div class="row no-gutters h-100">
      <div class="col-lg-5">
        <AuthLeftPart/>
      </div>
      <div class="col-lg-6">
        <div class="right-part h-100 d-flex justify-content-center align-items-center">
          <div class="right__content">
            <h1 class="mb-3">{{ $t('reset_password') }}</h1>
            <template v-if="token">
              <InputGroup :label="$t('new_password')"
                          type="password"
                          autocomplete="new-password"
                          @enter="submit()"
                          v-model="form.password"/>
              <ValidationError validation-id="password"/>
              <InputGroup :label="$t('confirm_password')"
                          type="password"
                          autocomplete="new-password"
                          @enter="submit()"
                          v-model="form.password_confirmation">
                <div class="text-danger mt-1"
                     v-if="form.password && form.password_confirmation && form.password !== form.password_confirmation">
                  {{ $t('passwords_do_not_match') }}
                </div>
              </InputGroup>
              <ValidationError validation-id="password_confirmation"/>
              <PasswordRequirementsChecklist :password="form.password" class="mb-3"/>
              <div class="form-group text-right mt-md-4 pt-3">
                <button @click="submit()"
                        :disabled="loading"
                        class="btn-themed login-btn">{{ $t('save') }}
                </button>
              </div>
              <div v-if="errors && errors.general" class="alert alert-danger py-2">
                {{ errors.general.join(', ') }}
              </div>
            </template>
            <div v-else class="alert alert-danger py-2">
              {{ $t('invalid_reset_link') }}
            </div>
            <div class="text-center mt-3">
              <router-link to="/login" class="small">{{ $t('signin') }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import InputGroup from "@/components/form/InputGroup"
import ValidationError from "@/components/form/ValidationError"
import PasswordRequirementsChecklist from "@/components/parts/staff/PasswordRequirementsChecklist.vue"
import AuthLeftPart from "@/components/parts/auth/AuthLeftPart.vue"
import { useStore } from "vuex"
import { useRoute, useRouter } from "vue-router"
import { computed, onMounted, reactive } from "vue"

const store = useStore()
const router = useRouter()
const route = useRoute()

const token = route.query.token || null

const form = reactive({
  password: "",
  password_confirmation: "",
})

onMounted(() => {
  store.commit('setError', {})
  if(token) {
    store.dispatch('getPasswordRequirements')
  }
})

const loading = computed(() => store.state.dom.loading)
const errors = computed(() => store.state.auth.errors)

const submit = async () => {
  if(form.password !== form.password_confirmation) return
  try {
    await store.dispatch('resetPassword', { token, ...form })
    router.push('/')
  } catch (error) {
    console.error('Reset password error:', error)
  }
}
</script>

<style lang="scss" scoped>
.login-btn {
  min-width: 200px;
  width: 100%;
}
</style>
